import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=c486b4e2&"
import script from "./Renew.vue?vue&type=script&lang=js&"
export * from "./Renew.vue?vue&type=script&lang=js&"
import style0 from "./Renew.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports